<template>
  <v-card border :class="{ active: docTypeRoute.id === activeRouteId }">
    <v-card-text class="text-black">
      <div class="d-flex justify-space-between ga-3">
        <div>
          <div class="d-flex align-center ga-3 mb-2">
            <span class="font-weight-bold font-size-15">
              {{ docTypeRoute.name }}
            </span>
            <v-chip
              v-if="docTypeRoute.isActive"
              size="small"
              color="success"
              density="compact"
              rounded="pill">
              <v-icon icon="mdi-check" class="mr-2"></v-icon>
              <span class="font-size-10 font-weight-bold">Активний</span>
            </v-chip>
            <v-chip
              v-else
              size="small"
              color="grey"
              density="compact"
              rounded="pill">
              <span class="font-size-10 font-weight-bold">Неактивний</span>
            </v-chip>
          </div>

          <div class="d-flex ga-3 align-center font-size-12 flex-wrap mb-3">
            <span class="text-disabled">
              {{ getPersonName(docTypeRoute.author, { initials: true }) }}
            </span>
            <span class="text-disabled vertical-line">
              {{ new CustomDate(docTypeRoute.updated_at).toString() }}
            </span>

            <div class="vertical-line">
              <span class="text-disabled">Режим: </span>
              <b> {{ docTypeRoute.type.name }}</b>
            </div>

            <div>
              <span class="text-disabled">Етапів: </span>
              <b> {{ docTypeRoute.stages.length }}</b>
            </div>
          </div>

          <div class="d-flex align-center ga-3 flex-wrap">
            <div
              v-for="(stage, idx) in sortStages(docTypeRoute.stages)"
              :key="stage.id"
              class="d-flex align-center ga-3">
              <v-chip
                density="comfortable"
                rounded="lg"
                :color="stage.typeId === 1 ? 'warning' : 'error'">
                <span class="font-weight-bold mr-1">
                  {{ stage.type.name }}
                </span>

                <span class="text-disabled">
                  <span class="mr-1">({{ stage.sequence }})</span>
                  <span v-if="stage.duration">{{ stage.duration }} дн.</span>
                  <span v-else>Без терміну</span>
                </span>
              </v-chip>
              <v-icon
                v-if="idx + 1 < docTypeRoute.stages.length"
                icon="mdi-arrow-right-thin"
                color="grey"></v-icon>
            </div>
          </div>
        </div>

        <div class="d-flex ga-3">
          <v-btn
            v-if="!docTypeRoute.isActive"
            density="compact"
            color="light-blue-darken-3"
            @click="routeSetActive(docTypeRoute.id)">
            Активувати
          </v-btn>
          <v-btn
            variant="outlined"
            density="compact"
            @click="routeUpdate(docTypeRoute)">
            <v-icon class="mr-2" icon="mdi-pencil"></v-icon>
            <span>Редагувати</span>
          </v-btn>
          <v-btn
            v-tooltip="'Видалити'"
            style="min-width: 48px"
            class="px-0"
            variant="outlined"
            color="error"
            density="compact"
            @click="routeDelete(docTypeRoute.id)">
            <v-icon icon="mdi-close"></v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import {
  DocumentTypeRoute,
  DocumentTypeRouteStageListItem,
} from '@/utils/types/documentRoute'
import { useRoutes } from './routes'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { sortStages } from './helpers'

defineOptions({
  name: 'RouteItem',
})

defineProps<{
  docTypeRoute: Omit<DocumentTypeRoute, 'stages'> & {
    stages: Array<DocumentTypeRouteStageListItem>
  }
}>()

const { routeUpdate, routeDelete, routeSetActive, activeRouteId } = useRoutes()
</script>

<style lang="scss" scoped>
.vertical-line {
  padding-right: 1rem;
  border-right: 2px solid #ccc;
}
.active {
  border: 2px solid rgb(var(--v-theme-info));
  background: rgba(var(--v-theme-info), var(--v-activated-opacity));
}
</style>
